import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=3d223206&scoped=true&"
import script from "./Assistance.vue?vue&type=script&lang=js&"
export * from "./Assistance.vue?vue&type=script&lang=js&"
import style0 from "./Assistance.vue?vue&type=style&index=0&id=3d223206&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d223206",
  null
  
)

export default component.exports